import api from '../lib/api';
import { AuditLogEntry, PaginatedResponse } from '../types';

export interface AuditLogFilters {
  page?: number;
  limit?: number;
  actorId?: string;
  action?: string;
  from?: string;
  to?: string;
}

export const auditLogApi = {
  list: (params: AuditLogFilters) =>
    api.get<PaginatedResponse<AuditLogEntry>>('/api/v1/admin/audit-log', { params }),
};
